import React from "react";
import "./Cards.css";

const Cards = (props) => {
  return (
    <div id="Card">
      <div id="image">
        <img src={props.src} alt="" />
      </div>
      <div id="text">
        {props.text}
      </div>
    </div>
  );
};

export default Cards;
